import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { MediaObserver } from "@angular/flex-layout";
import { CookieService } from "ngx-cookie-service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { MatDialog } from "@angular/material/dialog";
import { FuseNavigationService } from "@fuse/components/navigation/navigation.service";
import { FuseMatchMediaService } from "@fuse/services/match-media.service";
import { GeneralInformationComponent } from "app/layout/components/general-information/general-information.component";
import { FuseProgressBarService } from "../progress-bar/progress-bar.service";

import { fuseAnimations } from "@fuse/animations";
import { PayPendingComponent } from "app/layout/components/pay-pending/pay-pending.component";
import { AttendanceListProvider, PageOptions } from "cw-backend";
import moment from "moment";
import { ParametersOrderPayPending } from "../../../../shared/cw-backend/models/attendance/order-pay-pending";
import { UserService } from "../../../../shared/cw-backend/providers/security/user/user-service";
import { AuthService } from "../../../../shared/cw-services/auth/auth.service";
import { RolePermissionService } from "../../../../shared/cw-services/role/role-permission.service";
import { CwUtils } from "../../../../shared/cw-utils/cw-utils.service";
import { RefreshService } from "../../../../shared/cw-utils/refresh-service";

@Component({
    selector: "fuse-shortcuts",
    templateUrl: "./shortcuts.component.html",
    styleUrls: ["./shortcuts.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class FuseShortcutsComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    shortcutItems: any[];
    navigationItems: any[];
    filteredNavigationItems: any[];
    searching: boolean;
    mobileShortcutsPanelActive: boolean;
    isConnected: boolean = true;
    latency: any;
    user: any;
    intervalRef: any;
    @Input()
    navigation: any;
    existsOrderPayPending: string;
    @ViewChild("searchInput")
    searchInputField;

    @ViewChild("shortcuts")
    shortcutsEl: ElementRef;
    orderPayPendingList = new Array<any>();
    showTotem = false;
    showPendingPayments = false;
    parametersOrderPayPending = new ParametersOrderPayPending();

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {CookieService} _cookieService
     * @param {FuseMatchMediaService} _fuseMatchMediaService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {MediaObserver} _mediaObserver
     * @param {Renderer2} _renderer
     */
    constructor(
        private _cookieService: CookieService,
        private _fuseMatchMediaService: FuseMatchMediaService,
        private _fuseNavigationService: FuseNavigationService,
        private _mediaObserver: MediaObserver,
        private _matDialog: MatDialog,
        private progressBar: FuseProgressBarService,
        private rolePermissionService: RolePermissionService,
        private _renderer: Renderer2,
        private cwUtils: CwUtils,
        private authService: AuthService,
        private userService: UserService,
        private AttendanceListProvider: AttendanceListProvider,
        private refreshService: RefreshService,
    ) {
        // Set the defaults
        this.shortcutItems = [];
        this.searching = false;
        this.mobileShortcutsPanelActive = false;

        this.parametersOrderPayPending.pageOptions = new PageOptions();
        this.parametersOrderPayPending.pageOptions.sizePage = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void> {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.checkShowTotem();
        this.checkShowPendingPayments();

        let shortcut: string = await this.getShortcuts();

        //this.latencyInit();
        this.rolePermissionService.orderPendingEvent
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (res) => {
                    this.existsOrderPayPending = res;
                },
            });

        // Get the navigation items and flatten them
        this.filteredNavigationItems = this.navigationItems =
            this._fuseNavigationService.getFlatNavigation(this.navigation);

        if (CwUtils.checkStringIsNotNull(shortcut)) {
            this.shortcutItems = JSON.parse(shortcut);
        } else {
            if (this._cookieService.check("FUSE2.shortcuts")) {
                this.shortcutItems = JSON.parse(
                    this._cookieService.get("FUSE2.shortcuts"),
                );
                this.insertShortCuts(JSON.stringify(this.shortcutItems));
            } else {
                // User's shortcut items
                this.shortcutItems = [
                    {
                        title: "Painel Gerencial",
                        type: "item",
                        icon: "dashboard",
                        url: "aplicacao/dashboards/admin",
                    },
                    {
                        title: "Agenda",
                        type: "item",
                        icon: "today",
                        url: "/operacional/agendamento/marcacao",
                    },
                    {
                        title: "Atendimento",
                        type: "item",
                        icon: "receipt_long",
                        url: "/operacional/recepcao/os",
                    },
                    {
                        title: "Paciente",
                        type: "item",
                        icon: "person_outline",
                        url: "/cadastro/operacional/paciente",
                    },
                    {
                        title: "Agenda Profissional",
                        type: "item",
                        icon: "today",
                        url: "operacional/atendimento/agenda-profissional",
                    },
                    {
                        title: "Perfil",
                        type: "item",
                        icon: "contact_mail",
                        url: "/cadastro/seguranca/perfil",
                    },
                    {
                        title: "Usuário",
                        type: "item",
                        icon: "person_pin",
                        url: "/cadastro/seguranca/usuario",
                    },
                    {
                        title: "Convênio",
                        type: "item",
                        icon: "local_hospital",
                        url: "/cadastro/credenciamento/convenio",
                    },
                    {
                        title: "Procedimento",
                        type: "item",
                        icon: "healing",
                        url: "/cadastro/credenciamento/procedimento",
                    },
                    {
                        title: "Profissional",
                        type: "item",
                        icon: "people",
                        url: "/cadastro/organizacional/profissional",
                    },
                    {
                        title: "Operação",
                        type: "item",
                        icon: "build",
                        url: "/cadastro/operacional/operacao",
                    },
                ];
            }
        }

        
        this.getOrderPayPending();

        

        this.refreshService.refreshOrderPayPending$.subscribe(() => {
            console.log("EVENTO RECEBIDO");
            this.getOrderPayPending();
        });
    }

    ngAfterViewInit(): void {
        // Subscribe to media changes
        this._fuseMatchMediaService.onMediaChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                if (this._mediaObserver.isActive("gt-sm")) {
                    this.hideMobileShortcutsPanel();
                }
            });
    }

    async getShortcuts(): Promise<string> {
        if (!this.user?.id) {
            return "";
        }
        const res: any = await this.userService.getShortcuts(
            this.user.id,
            "FAVORITE_SHORTCUST",
        );
        return res.body;
    }

    insertShortCuts(value) {
        if (!this.user?.id) {
            return "";
        }
        this.userService
            .insertShortcuts(this.user.id, "FAVORITE_SHORTCUST", value)
            .then((res) => {});
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Search
     *
     * @param event
     */
    search(event): void {
        const value = event.target.value.toLowerCase();

        if (value === "") {
            this.searching = false;
            this.filteredNavigationItems = this.navigationItems;

            return;
        }

        this.searching = true;

        this.filteredNavigationItems = this.navigationItems.filter(
            (navigationItem) => {
                return navigationItem.title.toLowerCase().includes(value);
            },
        );
    }

    /**
     * Toggle shortcut
     *
     * @param event
     * @param itemToToggle
     */
    toggleShortcut(event, itemToToggle): void {
        event.stopPropagation();

        for (let i = 0; i < this.shortcutItems.length; i++) {
            if (this.shortcutItems[i].url === itemToToggle.url) {
                this.shortcutItems.splice(i, 1);

                // Save to the cookies
                this._cookieService.set(
                    "FUSE2.shortcuts",
                    JSON.stringify(this.shortcutItems),
                );
                this.insertShortCuts(JSON.stringify(this.shortcutItems));

                return;
            }
        }

        this.shortcutItems.push(itemToToggle);

        // Save to the cookies
        this._cookieService.set(
            "FUSE2.shortcuts",
            JSON.stringify(this.shortcutItems),
        );
        this.insertShortCuts(JSON.stringify(this.shortcutItems));
    }

    /**
     * Is in shortcuts?
     *
     * @param navigationItem
     * @returns {any}
     */
    isInShortcuts(navigationItem): any {
        return this.shortcutItems.find((item) => {
            return item.url === navigationItem.url;
        });
    }

    /**
     * On menu open
     */
    onMenuOpen(): void {
        setTimeout(() => {
            this.searchInputField.nativeElement.focus();
        });
    }

    /**
     * Show mobile shortcuts
     */
    showMobileShortcutsPanel(): void {
        this.mobileShortcutsPanelActive = true;
        this._renderer.addClass(
            this.shortcutsEl.nativeElement,
            "show-mobile-panel",
        );
    }

    /**
     * Hide mobile shortcuts
     */
    hideMobileShortcutsPanel(): void {
        this.mobileShortcutsPanelActive = false;
        this._renderer.removeClass(
            this.shortcutsEl.nativeElement,
            "show-mobile-panel",
        );
    }

    generalInformation() {
        this.progressBar.hide();
        const dialogRef = this._matDialog.open(GeneralInformationComponent, {
            width: "80%",
            height: "88vh",
            panelClass: "clearPadding",
            //data: this.surgerySchedule.patient,
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    openPayPending() {
        this.progressBar.hide();
        const dialogRef = this._matDialog.open(PayPendingComponent, {
            height: "80%",
            width: "80%",
            panelClass: "clearPadding",
            //data: this.surgerySchedule.patient,
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    checkShowTotem() {
        let permissiona = JSON.parse(localStorage.getItem("views"));
        let index = permissiona?.findIndex(
            (p) =>
                p.code == "application-configurations-use_call_password-list",
        );
        this.showTotem = index >= 0;
    }

    checkShowPendingPayments() {
        let permissiona = JSON.parse(localStorage.getItem("views"));
        let index = permissiona?.findIndex(
            (p) =>
                p.code == "application-configurations-pending_payments-list",
        );
        this.showPendingPayments = index >= 0;
    }


    latencyInit() {
        let isAuthenticated = this.authService.currentUserToken;

        this.userService.userAction
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((action) => {
                if (action == "LOGOUT") {
                    this.latencyStop();
                    return;
                }
            });

        if (isAuthenticated != null) {
            //   this.latencyStart();
        }
    }

    latencyStart() {
        /* this.intervalRef = setInterval(() => {
            this.cwUtils.getLatency().then((latency) => {
               // console.log("🚀 ~ this.cwUtils.getLatency ~ latency:", latency)
                if (latency == -1) {
                    this.isConnected = false;
                } else {
                    this.latency = latency;
                    this.isConnected = true;
                }
            });
        }, 60000);*/
    }

    latencyStop() {
        clearInterval(this.intervalRef);
    }

    getOrderPayPending(event?, type?) {

         if (!this.user?.id) {
            return "";
        }
        switch (type) {
            case "short":
                this.parametersOrderPayPending.pageOptions.fieldSort =
                    event.active;
                this.parametersOrderPayPending.pageOptions.sortDirection =
                    event.direction;
                break;
            case "page":
                this.parametersOrderPayPending.pageOptions.page =
                    event.pageIndex;
                this.parametersOrderPayPending.pageOptions.sizePage =
                    event.pageSize;
                break;

            default:
                this.parametersOrderPayPending.pageOptions.page = 0;
                this.parametersOrderPayPending.pageOptions.sizePage = 10;
                break;
        }

        this.parametersOrderPayPending.pageOptions.fieldSort = "name";
        this.parametersOrderPayPending.pageOptions.sortDirection = "desc";

        this.parametersOrderPayPending.dateStart = moment()
            .startOf("month")
            .format("YYYY-MM-DD");

        this.parametersOrderPayPending.dateFinish = moment()
            .endOf("month")
            .format("YYYY-MM-DD");

        this.AttendanceListProvider.getOrdersPayPending(
            this.parametersOrderPayPending,
        ).then((res) => {
            this.orderPayPendingList = res.body.content;
          
        });
    }
}
